import { render, staticRenderFns } from "./shroud.vue?vue&type=template&id=6e68f2a0&scoped=true&"
import script from "./shroud.vue?vue&type=script&lang=js&"
export * from "./shroud.vue?vue&type=script&lang=js&"
import style0 from "./shroud.vue?vue&type=style&index=0&id=6e68f2a0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e68f2a0",
  null
  
)

export default component.exports